module.exports = __webpack_public_path__ + "img/home-destinations.f9fa3d90.svg";